(function () {
  'use strict';

  function dashboardActivityOptionsDataService($http) {
      var baseUrl = '[BuildifyApiHost]/api/dashboardactivityoptions';

      function getDashboardActivityOptions() {
          return $http.get(baseUrl).then(
              function (response) {
                  return response.data;
              });
      }

      function getDashboardActivityOptionsForEntity(entityId) {
        return $http.get(baseUrl + '/' + entityId).then(
            function (response) {
                return response.data;
            });
    }

      return {
        getDashboardActivityOptions: getDashboardActivityOptions,
        getDashboardActivityOptionsForEntity: getDashboardActivityOptionsForEntity
      }
  }

  dashboardActivityOptionsDataService.$inject = ['$http'];

  angular.module('ecap.dashboards').service('dashboardActivityOptionsDataService', dashboardActivityOptionsDataService);
})();
